import React from 'react';
import PropTypes from 'prop-types';

import styles from './ImpactSummary.module.scss';
import TradePriceToday from './tradepricedtoday/TradePricedToday';
import ImImpactSummary from './imimpactsummary/ImImpactSummary';

const ImpactSummary = props => (
    <div className={ styles.impactSummaryWrapper }>
        <div className={ styles.tradePriceToday }>
            <TradePriceToday readOnly={ props.readOnly } />
        </div>
        <div className={ styles.imImpactSummary }>
            <ImImpactSummary readOnly={ props.readOnly } />
        </div>
    </div>
);

ImpactSummary.propTypes = {
    readOnly: PropTypes.bool
};

ImpactSummary.defaultProps = {
    readOnly: false
};

export default ImpactSummary;
